import { render, staticRenderFns } from "./UserUnlimitedTokensConfirmation.vue?vue&type=template&id=fe832a76"
import script from "./UserUnlimitedTokensConfirmation.vue?vue&type=script&lang=js"
export * from "./UserUnlimitedTokensConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports